import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { IntegrityMonitorEventsDataProvider } from '../dataProvider/IntegrityMonitorEventsDataProvider';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class IntegrityMonitorEventsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorEventsDataProvider);
  }
}
